// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1C6It","boxTitle":"Qualiphy_boxTitle__2D2Nx","box":"Qualiphy_box__6Aq4u","toggleWrap":"Qualiphy_toggleWrap__37u1T"};